import { Component, HostListener, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup, ValidationErrors, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/services/api.service';
import * as REGEX from '../../../shared/regex';
import { MainService } from 'src/app/services/main.service';
import { SharedService, userProfile } from 'src/app/services/shared.service';
import { localStorageService } from 'src/app/services/localstorage.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { LogoutModalComponent } from 'src/app/shared/logout-modal/logout-modal.component';
import { environment } from 'src/environments/environment';
import Clarity from '@microsoft/clarity';
import { NgxMaskDirective } from 'ngx-mask';
import { LegalDocumentsComponent } from 'src/app/pages/public/legal-documents/legal-documents.component';
import { LegalDocumentsService } from 'src/app/services/legal-documents.service';
import { ConsentCaptureService, ConsentCapture } from 'src/app/services/consent-capture.service';

@Component({
    selector: 'app-business-info',
    templateUrl: './business-info.component.html',
    styleUrl: './business-info.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule, ReactiveFormsModule, NgxMaskDirective]
})

export class BusinessInfoComponent implements OnInit {
  public environment = environment;
  industryList: any = [];
  sub_industries: any = [];
  practiceInfoForm: UntypedFormGroup = {} as UntypedFormGroup; // Default value
  mask = '(000) 000-0000';
  country_data: any;
  userProfile!: userProfile;
  showLogout: boolean = false;
  bsModalRef: BsModalRef | undefined;
  google_id: string | undefined;
  /** Set once the legal documents have been accepted in the modal. */
  checkBtn: boolean = false;
  consentCapture: ConsentCapture | null = null;

  constructor(
    private modalService: BsModalService,
    private _main: MainService,
    private formBuilder: UntypedFormBuilder,
    private apiSer: ApiService,
    private _router: Router, private _shared: SharedService, private _local: localStorageService,
    private _legal: LegalDocumentsService, private _consent: ConsentCaptureService
  ) { }

  @HostListener('document:click', ['$event.target'])
  onClick(event: EventTarget | null): void {
    if (!(event instanceof Element)) { return; }
    if (!event.classList.contains('lhc') && !event.classList.contains('logout-wrapper') && !event.classList.contains('profile-icon')) {
      this.showLogout = false;
    }
  }
  
  ngOnInit() {
    this.getIndustryList();
    this.practiceInfoForm = this.formBuilder.group({
      practice_name: ['', [Validators.required,  Validators.maxLength(100)]],  //Validators.pattern(REGEX.Name_1),
      practice_email: ['', [Validators.required, Validators.pattern(REGEX.Email)]],
      practice_mobile: ['', [Validators.required, Validators.pattern(REGEX.number_regex)]],
      ind_name: [''],
      ind_id: ['', [Validators.required]],
      doctor_speciality_name: [''],
      doctor_speciality: ['', [Validators.required]],
      web_url: ['', [Validators.required,Validators.pattern(REGEX.URL_regex)
    ]],
      practice_type: ['', [Validators.required]]
    });
    this._shared.country_currency_info$.subscribe(data => {
      if (data && data.country && data.country['country_phone_format']) {
        this.country_data = data.country;
        this.mask = data.country['country_phone_format'];
      }
    })
    this._legal.preload();
    this._shared.doctorProfile$.subscribe((doctorProfile: userProfile) => {
      this.userProfile = doctorProfile;
      this.google_id = this.userProfile.google_id;
    })
  }
  checkSubIndustry(value: any) {
    const specialityNameControl = this.practiceInfoForm.get('doctor_speciality_name');

    if (+value == 9999) {
      specialityNameControl?.setValidators([Validators.required]);
    } else {
      this.practiceInfoForm.patchValue({ ind_name: ''});
      specialityNameControl?.clearValidators();
    }

    specialityNameControl?.updateValueAndValidity();
  }
  getIndustryList() {
    this.apiSer.api({ is_verified: 1 }, 'profile/get_industry_list', 'get').subscribe((data: any) => {
      if (data && data.is_error == 0) {
        this.industryList = data.industries;
        // if (this.industryList && this.industryList.length) {
        //   if (this.industryList[0]['ind_id'] == 9999) {
        //     this.practiceInfoForm.controls['ind_name'].setValidators([Validators.required])
        //   }
        //   this.practiceInfoForm.patchValue({ ind_id: this.industryList[0]['ind_id'] });
        //   this.practiceInfoForm.patchValue({ ind_name: '' });
        // }
        // this.getSubIndustrylist();
      } else {
        this.industryList = [];
      }
    });
  }

  getSubIndustrylist() {
    const data = {
      ind_id: parseInt(this.practiceInfoForm.controls['ind_id'].value),
      is_deleted: 0,
      is_verified: 1,
      full_data: 0,
    };
    this.apiSer.api(data, 'profile/get_all_sub_industries', 'get').subscribe((data: any) => {
      if (data && data.is_error == 0) {
        if (data.paignated_result && data.paignated_result.length) {
          if (data.paignated_result[0]['doctor_speciality'] == 9999) {
            this.practiceInfoForm.controls['doctor_speciality_name'].setValidators([Validators.required])
          } else {
            this.practiceInfoForm.controls['doctor_speciality_name'].clearValidators();
          }
          // this.practiceInfoForm.patchValue({ 'doctor_speciality': data.paignated_result[0].doctor_speciality });
          this.practiceInfoForm.patchValue({ 'doctor_speciality_name': '',
             doctor_speciality: '', 
           });
        }
        this.sub_industries = data.paignated_result;
        this.practiceInfoForm.updateValueAndValidity();
      } else {
        this.sub_industries = [];
      }
    });
  }

  async submitPracticeInfo() {
    if (this.practiceInfoForm.invalid) {
      this.practiceInfoForm.markAsDirty();
      this.practiceInfoForm.markAllAsTouched();
      return;
    }

    // Google accounts are created straight from the OAuth callback, so this is
    // where their consent is taken. Accepting re-enters this method with
    // checkBtn set and the save goes through.
    if (this.google_id && !this.checkBtn) {
      this.openLegalDocuments(true);
      return;
    }

    // Screenshot may already exist from an earlier accept. File it only now,
    // immediately before the business profile is saved.
    try {
      await this.uploadConsent();
    } catch (err) {
      console.error('[consent] upload failed', err);
    }

    const data = {
      practice_name: this.practiceInfoForm.controls['practice_name'].value,
      practice_email: this.practiceInfoForm.controls['practice_email'].value,
      practice_mobile: this.practiceInfoForm.controls['practice_mobile'].value + '',
      practice_mobile_country_code: '+1',//this.practiceInfoForm.controls['practice_mobile_country_code'].value,
      ind_id: this.practiceInfoForm.controls['ind_id'].value,
      sub_ind_id: this.practiceInfoForm.controls['doctor_speciality'].value,
      ind_name: this.practiceInfoForm.controls['ind_name'].value,
      sub_ind_name: this.practiceInfoForm.controls['doctor_speciality_name'].value,
      web_url:this.practiceInfoForm.controls['web_url'].value,
      practice_type: this.practiceInfoForm.controls['practice_type'].value
    }
    this.apiSer.api(data, 'profile/business_setting').subscribe((data) => {
      if (data.is_error == 0) {
        const userData = this._local.customGetItem('userProfileData');
        console.log('doctor_email', userData.doctor_email);
        Clarity.setTag('doctor_email', userData ? userData.doctor_email : '');
        Clarity.identify(userData.doctor_email, userData ? userData.doctor_email : '', userData ? userData.doctor_email : '', userData ? userData.doctor_name : '');
        this._router.navigate(['app', 'dashboard']);
        this._main.accessTokenLogin();
      } else {
        this.practiceInfoForm.markAsDirty();
        this.practiceInfoForm.markAsTouched();
        window.scroll(0, 0);
      }
    });
  }

  showModal() {
    this.showLogout = true;
  }

  trimData(){
    this.practiceInfoForm.controls['practice_name'].setValue(this.practiceInfoForm.controls['practice_name'].value.trim());
    this.practiceInfoForm.controls['practice_email'].setValue(this.practiceInfoForm.controls['practice_email'].value.trim());
    
  }

  logoutModal() {
    const initialState = {
    };
    this.bsModalRef = this.modalService.show(LogoutModalComponent, {
      initialState,
      class: 'modal-dialog-centered'
    });
  }

  /**
   * Presents the same legal documents as signup. Google accounts are created
   * straight from the OAuth callback, so this is where their consent is taken
   * — read through, accepted, and captured as a record like every other.
   *
   * @param continueSubmit true when Continue opened this and the save should
   * follow once accepted. Opening it from the notice is a read-through: accept
   * captures the screenshot only. The upload runs later, just before save.
   */
  openLegalDocuments(continueSubmit = false): void {
    this.bsModalRef = this.modalService.show(LegalDocumentsComponent, {
      initialState: {
        businessName: this.userProfile?.doctor_name || ''
      },
      class: 'modal-dialog-centered modal-lg legal-modal-wrapper',
      ignoreBackdropClick: true,
      keyboard: false
    });

    const modal = this.bsModalRef.content as LegalDocumentsComponent;

    modal.onAccept.subscribe(async (dismiss: () => void) => {
      try {
        this.consentCapture = await this._consent.capture(document.body, { viewport: true });
      } finally {
        dismiss();
      }
      this.checkBtn = true;
      if (continueSubmit) {
        this.submitPracticeInfo();
      }
    });

    modal.onDecline.subscribe(() => {
      this.checkBtn = false;
      this.consentCapture = null;
    });
  }

  /** Files the captured consent record. Called only immediately before save. */
  private async uploadConsent(): Promise<void> {
    const profile = this._local.customGetItem('userProfileData');
    const doctorId = profile && profile.doctor_id;
    if (!this.consentCapture || !doctorId) {
      return;
    }
    const capture = this.consentCapture;
    const formData = new FormData();
    const file = await this._shared.base64ToBlob(capture.image);
    formData.append('doctor_consent', file, `consent-${doctorId}.jpg`);
    formData.append('doctor_id', String(doctorId));
    formData.append('captured_at', capture.captured_at);
    formData.append('terms_version', capture.terms_version);
    formData.append('privacy_version', capture.privacy_version);
    formData.append('user_agent', capture.user_agent);
    formData.append('timezone', capture.timezone);
    formData.append('viewport', capture.viewport);
    formData.append('origin', capture.origin);
    formData.append('page_url', capture.page_url);

    await new Promise<void>(resolve => {
      this.apiSer.uploadApi(formData, 'auth/upload_doctor_consent').subscribe({
        next: response => {
          const body = response?.body;
          if (body && body.is_error) {
            console.error('[consent] upload rejected', body.original_text || body);
          }
        },
        error: err => {
          console.error('[consent] upload failed', err?.status, err?.message || err);
          resolve();
        },
        complete: () => resolve()
      });
    });
  }

preventLeadingSpace(event: KeyboardEvent) {
  const input = event.target as HTMLInputElement;
  if (event.key === ' ' && input.selectionStart === 0) {
    event.preventDefault();
  }
}


}
